import script from "./BaseTableDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTableDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTableDialog.vue?vue&type=style&index=0&id=684bb6bd&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684bb6bd"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
